import { CmsApiFormBuilderBlockData } from 'modules/cms/api/types/blocks/CmsApiFormBuilderBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpFormBuilderBlock } from './CmsAmpFormBuilderBlock';
import { CmsFormBuilderBlock } from './CmsFormBuilderBlock';

export const CmsFormBuilderBlockMapping: CmsBlockMapping<CmsApiFormBuilderBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsFormBuilderBlock,
    AmpComponent: CmsAmpFormBuilderBlock,
  };
